import React from 'react';
import SubHeader from '../../../layout/components/SubHeader';
import FeatureCard from './FeatureCard';
import './Features.css';

function Features() {
    return (
        <div className="ecx-page clinic-settings-page features-page ecx-page--full-width">
            <SubHeader
                title="EyeconX Features"
                description="View the services and capabilities enabled for your clinic"
                icon="bi-stars"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <FeatureCard />
            </div>
        </div>
    );
}

export default Features;
